export const expandCard = (
  innerContainerRef,
  outerContainerRef,
  isExpanded,
  dom,
  defaultHeight = 279
) => {
  let container_height = innerContainerRef.offsetHeight + 107;

  if (isExpanded) {
    container_height = defaultHeight;
  }

  let container_height_px = `${container_height}px`;
  outerContainerRef.style.height = container_height_px;

  dom.setState({
    componentHeight: container_height_px,
    isExpanded: !isExpanded,
  });
};
